import { render, staticRenderFns } from "./AuthorizedUserAccess.vue?vue&type=template&id=bca1f1e0&scoped=true"
import script from "./AuthorizedUserAccess.vue?vue&type=script&lang=js"
export * from "./AuthorizedUserAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca1f1e0",
  null
  
)

export default component.exports